module.exports = __webpack_public_path__ + "static/media/scroll3_1.38cd0620.png";